import React, { ReactElement, useState, useEffect } from 'react'
import GeneralPage from '../../components/General/GeneralPage/GeneralPage'
import Tile from '../../components/General/Tile/Tile'
import { useLocation, useNavigate } from 'react-router-dom'
import LoginButton from '../../components/General/Button/LoginButton'
import { useAuth } from '../../context/AuthContext'
import styles from '../../components/General/GeneralPage/GeneralPage.module.scss'; // Import the styles

interface Props { }

export default function Login(props: Props): ReactElement {

    const { state } = useLocation()
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string>(null)
    const { isAuthenticated } = useAuth();

    const from = (state && state['from']) || { pathname: '/' }

    console.log(isAuthenticated)

    useEffect(() => {
        if (isAuthenticated) {
            navigate(from)
        }
    }, [isAuthenticated])

    return (
        <GeneralPage className={styles.GeneralPage__loginPage}>

            <div className="row justify-content-md-center">
                <div className="col col-md-4">
                    <img style={{ width: "150px", display: "block", margin: "0 auto 5rem auto" }} src="/smith-gas-logo.png" alt="Smith Gas Liquids Logo" />
                    <Tile>
                        <div style={{ textAlign: "center", fontWeight: "600", marginBottom: "2rem" }}><h6>WELCOME TO</h6>
                            <h3 style={{ fontWeight: "900" }}>GasPoint</h3>
                        </div>
                        {errorMessage && <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>}
                        <div style={{ textAlign: "center" }}><LoginButton setErrorMessage={setErrorMessage}></LoginButton></div>
                    </Tile>
                </div>
            </div>

        </GeneralPage>
    )
}
